import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectors } from "reducers";
import ModalLink from "components/shared/modal-link";
import { canOpenUserProfile } from "utils/user-profile-permissions";

/*
 * S3DEV2-7730: links a user's name to their profile only when the viewer can open
 * it; otherwise the name is plain text. Use linkedUserIsS3Staff where the linked
 * user is an S3 coach or staff member (patient and order pages). Use modal where a
 * ModalLink was used, so system tray modals still close on navigation.
 */
const UserProfileLink = ({ userId, linkedUserIsS3Staff, modal, children }) => {
  const userRole = useSelector(selectors.getUserRole);

  if (!userId || !canOpenUserProfile(userRole, { linkedUserIsS3Staff })) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  const LinkComponent = modal ? ModalLink : Link;
  return <LinkComponent to={`/users/${userId}`}>{children}</LinkComponent>;
};

export default UserProfileLink;

UserProfileLink.defaultProps = {
  linkedUserIsS3Staff: false,
  modal: false
};

UserProfileLink.propTypes = {
  userId: PropTypes.string,
  linkedUserIsS3Staff: PropTypes.bool,
  modal: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};
